
import { Options, mixins } from "vue-class-component";
import HomepageService from "../../service/HomepageService";
import Toaster from "../../helpers/Toaster";
import moment from "moment";
import { camelCase } from "lodash";
import UtilityOptions from "../../mixins/UtilityOptions";
import PosService from "../../service/PosService.js";

interface ChartTypes {
    name: string;
    amount: number;
}

interface RevenueTypes {
    totalSale: number;
    totalSalesRefund: number;
    totalPurchase: number;
    totalPurchaseReturns: number;
    transDate: string;
    totalStockGain: number;
    totalStockLoss: number;
    totalStockTransferOut: number;
    totalStockTransferIn: number;
}

@Options({
    components: {},
    title: "Dashboard",
})
export default class Homepage extends mixins(UtilityOptions) {
    private pharmacies;
    private pharmacyId = "";
    private branchName = "";
    private branchID = "";
    private currentBranchID = "";
    private receiptService;
    private dashInfo = {
        shortageQty: 0,
        upcomingExpiry: 0,
        expired: 0,
        accountHolders: 0,
        monthlyExpense: 0,
        itemsQty: 0,
        salesToday: 0,
        salesQty: 0,
        salesMonth: 0,
        returnToday: 0,
        returnMonth: 0,
        expenseToday: 0,
        purchaseToday: 0,
        purchaseMonth: 0,
        purchaseReturnToday: 0,
        purchaseReturnMonth: 0,
        transferToday: 0,
        transferMonth: 0,
        cashInToday: 0,
        cashInMonth: 0,
        cashAtBankToday: 0,
        cashAtBankMonth: 0,
        payLaterBalance: 0,
        stockGainToday: 0,
        stockGainMonth: 0,
        stockLossToday: 0,
        stockLossMonth: 0,
        stockTransferInToday: 0,
        stockTransferOutToday: 0,
        netStockTransferToday: 0,
        stockTransferInMonth: 0,
        stockTransferOutMonth: 0,
        netStockTransferMonth: 0,
    };

    private recentlyItems = [];
    private revenueExpense: RevenueTypes[] = [];
    private monthList = [];
    private dayList = [];
    private topBrands: ChartTypes[] = [];
    private topUsers: ChartTypes[] = [];
    private topCustomers: ChartTypes[] = [];
    private homepageTxn;
    private toast;

    private itemFilter = {
        keyword: "",
        filterType: "None",
        storeID: 0,
        date1: "",
        date2: "",
        type: "INE",
        customerName: "All",
        UserName: "All",
        customerID: 0,
        userID: 0,
    };

    private multiAxisOptions = {
        responsive: true,
        tooltips: {
            mode: "index",
            titleFontSize: 30,
            bodyFontSize: 22,
            intersect: true,
        },
    };

    private storeActivityChartOptions = {
        responsive: true,
        tooltips: {
            mode: "index",
            titleFontSize: 30,
            bodyFontSize: 22,
            intersect: true,
        },
        scales: {
            // yAxes: [
            //   {
            //     type: "linear",
            //     display: false,
            //     position: "left",
            //     id: "y-axis-1",
            //   },
            // ],
        },
    };

    //DEFAULT METHOD OF TYPE SCRIPT
    //CALLING WHENEVER COMPONENT LOADS
    created() {
        this.receiptService = new PosService();
        this.homepageTxn = new HomepageService();
        this.toast = new Toaster();
    }

    mounted() {
        this.pharmacies = [];
        this.getHomepageDetails();
        // this.dashInfo.payLaterBalance  = this.generatepayLaterBalance();
        // console.log("DASHBOARD AVG INFO ",this.fetchpayLaterBalance());
    }

    camelizeKeys = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map((v) => this.camelizeKeys(v));
        } else if (obj !== null && obj.constructor === Object) {
            return Object.keys(obj).reduce(
                (result, key) => ({
                    ...result,
                    [camelCase(key)]: this.camelizeKeys(obj[key]),
                }),
                {}
            );
        }
        return obj;
    };

    changePharmacy(){
        // this.stores = this.pharmacies.filter(
        //     (e) => e.id == this.pharmacyId
        // );
    }

    changeBranch(){
        if(this.currentBranchID == this.branchID){
            return;
        }
        this.homepageTxn.setBranch(this.branchID).then((res) => {
            if(res.success) {
                this.getHomepageDetails();
                this.toast.showSuccess(res.message || "Branch changed successfully");
            } else {
                this.toast.showError(res.message || "Failed to change branch");
                // Reset to current branch if change failed
                this.branchID = this.currentBranchID;
            }
        }).catch((err) => {
            this.toast.showError(err.response?.data?.message || "Failed to change branch");
            // Reset to current branch if change failed
            this.branchID = this.currentBranchID;
        });
    }

    get stores() {
        if(this.pharmacyId !== ""){
            return this.pharmacies.reduce((acc, pharmacy) => {
                if (pharmacy.id === this.pharmacyId) {
                    acc = pharmacy.branches;
                }
            return acc;
            }, []);
        }
        return [];
    }

    getHomepageDetails() {
        this.homepageTxn.getHompageDetails(this.branchID).then((res) => {
            const d = this.camelizeKeys(res);

            this.topBrands = d.topBrandsAmount;
            this.topUsers = d.topUsers;
            this.topCustomers = d.topCustomers;

            this.dashInfo.shortageQty = d.shortageQty;
            this.dashInfo.upcomingExpiry = d.upcomingExpiry;
            this.dashInfo.expired = d.expired;
            this.dashInfo.accountHolders = d.accountHolders;
            this.dashInfo.monthlyExpense = d.monthlyExpense;
            this.dashInfo.itemsQty = d.itemsQty;
            this.dashInfo.salesToday = d.salesToday;
            this.dashInfo.salesQty = d.salesQty;
            this.dashInfo.salesMonth = d.salesMonth;
            this.dashInfo.returnToday = d.returnToday;
            this.dashInfo.returnMonth = d.returnMonth;
            this.dashInfo.expenseToday = d.expenseToday;
            this.dashInfo.purchaseToday = d.purchaseToday;
            this.dashInfo.purchaseMonth = d.purchaseMonth;
            this.dashInfo.purchaseReturnToday = d.purchaseReturnToday;
            this.dashInfo.purchaseReturnMonth = d.purchaseReturnMonth;
            this.dashInfo.transferToday = d.transferToday;
            this.dashInfo.transferMonth = d.transferMonth;
            this.dashInfo.cashInToday = d.cashInToday;
            this.dashInfo.cashInMonth = d.cashInMonth;
            this.dashInfo.cashAtBankToday = d.cashAtBankToday;
            this.dashInfo.cashAtBankMonth = d.cashAtBankMonth;
            this.recentlyItems = d.recentlyAdded;
            this.branchName = d.storeInfo.name;
            this.dashInfo.stockGainToday  = d.stockGainToday;
            this.dashInfo.stockGainMonth  = d.stockGainMonth;
            this.dashInfo.stockLossToday  = d.stockLossToday;
            this.dashInfo.stockLossMonth  = d.stockLossMonth;
            this.dashInfo.stockTransferInToday = d.stockTransferInToday;
            this.dashInfo.stockTransferOutToday = d.stockTransferOutToday;
            this.dashInfo.netStockTransferToday = d.netStockTransferToday;
            this.dashInfo.stockTransferInMonth = d.stockTransferInMonth;
            this.dashInfo.stockTransferOutMonth = d.stockTransferOutMonth;
            this.dashInfo.netStockTransferMonth = d.netStockTransferMonth;
            // set pay later balance
            d.payLaterBalance.forEach((e) => {
                //  console.log("Pay Later  ",e);
                this.dashInfo.payLaterBalance +=
                    Number(e.totalBill) -
                    Number(
                        e.cumulativeTotalAmount == null
                            ? 0
                            : e.cumulativeTotalAmount
                    );
            });

            //this.branchID                     = d.storeInfo.id;

            this.monthList = d.lastMonths;
            this.dayList = d.last30Days;
            this.revenueExpense = d.revenueExpense;
            // this.stores = d.stores;
            this.pharmacies = d.pharmacies;

            this.branchID = d.storeInfo.id;
            this.currentBranchID = d.storeInfo.id;
            this.pharmacyId = d.storeInfo.pharmacyId;

            // console.log("daylist ",this.dayList);
            // console.log("monthlist ",this.monthList);
        });
    }

    // generateAverageBillValue(){
    //   console.log("GENERATE AVG BLL VALUE ");
    //   let dataReturn;
    //   this.receiptService
    //           .transactionSummary(this.itemFilter)
    //           .then(data => {
    //             dataReturn=data.averageBillValue;
    //             console.log("PRINT AVG BLL VALUE 1",dataReturn);
    //           });
    //           console.log("PRINT AVG BLL VALUE 2",dataReturn);
    //   return dataReturn;
    // }

    async generateAverageBillValue() {
        // console.log("GENERATE AVG BLL VALUE");
        // try {
        //     let data = await this.receiptService.transactionSummary(this.itemFilter);
        //     console.log("PRINT AVG BLL VALUE 1", data.averageBillValue);
        //     return data.averageBillValue; // Ensure the function returns the resolved value
        // } catch (error) {
        //     console.error("Error fetching average bill value:", error);
        //     return null; // Return a default value in case of an error
        // }
    }

    async fetchAverageBillValue() {
        // let avgBillValue = await this.generateAverageBillValue();
        // this.dashInfo.averageBillValue = avgBillValue;
        // console.log("PRINT AVG BLL VALUE 2", avgBillValue); // Now this will have the correct value
    }

    navigateToExpiryReport() {
        this.$router.push("/report/expiry-report");
    }

    navigateToNearExpiryReport() {
        this.$router.push("/report/near-expiry-report");
    }
    navigateToStockAlertReport() {
        this.$router.push("/report/stock-alert-report");
    }
    navigatePayLater() {
        this.$router.push("/process/transactions?additionalFilter=PayLater");
    }

    get getRevenueExpenseChart() {
        let dayName: string[] = [];
        let totalSale: number[] = [];
        let totalSalesRefund: number[] = [];
        let totalPurchase: number[] = [];
        let totalPurchaseReturns: number[] = [];
        let totalStockGain: number[] = [];  
        let totalStockLoss: number[] = [];
        let totalStockTransferOut: number[] = [];
        let totalStockTransferIn: number[] = [];

        this.dayList.map((m) => {
            // this.monthList.map(m => {
            // const s = moment(m,'MM').format('MMM');
            // const i = this.revenueExpense.filter(n => Number(m) == Number(n.transMonth));

            //const s = moment(m,'MM').format('MMM');
            const date = m;
            //       const formatted = moment(date).format("DD MMM");

            //console.log(" revenue expense ",this.revenueExpense);
            const i = this.revenueExpense.filter(
                (n) => moment(n.transDate).format("DD MMM") == date
            );
            // console.log("REVENUE EXPENSES  ",this.revenueExpense);
            if (i.length > 0) {
                totalSale.push(this.formatAmount(i[0].totalSale));
                totalSalesRefund.push(this.formatAmount(i[0].totalSalesRefund));
                totalPurchase.push(this.formatAmount(i[0].totalPurchase));
                totalPurchaseReturns.push(
                    this.formatAmount(i[0].totalPurchaseReturns)
                );
                totalStockGain.push(this.formatAmount(i[0].totalStockGain)); 
                totalStockLoss.push(this.formatAmount(i[0].totalStockLoss));
                totalStockTransferOut.push(this.formatAmount(i[0].totalStockTransferOut));
                totalStockTransferIn.push(this.formatAmount(i[0].totalStockTransferIn));
            } else {
                totalSale.push(this.formatAmount(0));
                totalSalesRefund.push(this.formatAmount(0));
                totalPurchase.push(this.formatAmount(0));
                totalPurchaseReturns.push(this.formatAmount(0));
                totalStockGain.push(0); 
                totalStockLoss.push(0);
                totalStockTransferOut.push(0);
                totalStockTransferIn.push(0);
            }

            dayName.push(m);
        });

        return [
            dayName,
            totalSale,
            totalSalesRefund,
            totalPurchase,
            totalPurchaseReturns,
            totalStockGain, 
            totalStockLoss,
            totalStockTransferOut,
            totalStockTransferIn,
        ];
    }

    get sortBand() {
        let names: string[] = [];
        let amount: number[] = [];

        if (this.topBrands != null) {
            const sorted = this.topBrands.slice(0);
            sorted.sort(function (a, b) {
                return a.amount - b.amount;
            });

            sorted.map((e) => {
                amount.push(e.amount);
                names.push(e.name);
            });

            amount = amount.reverse().slice(0, 4);
            names = names.reverse().slice(0, 4);
        }

        return [names, amount];
    }

    get sortCustomers() {
        let names: string[] = [];
        let amount: number[] = [];

        if (this.topCustomers != null) {
            const sorted = this.topCustomers.slice(0);
            sorted.sort(function (a, b) {
                return a.amount - b.amount;
            });

            sorted.map((e) => {
                amount.push(e.amount);
                names.push(e.name);
            });

            amount = amount.reverse().slice(0, 4);
            names = names.reverse().slice(0, 4);
        }
        return [names, amount];
    }

    get sortUsers() {
        let names: string[] = [];
        let amount: number[] = [];

        if (this.topUsers != null) {
            const sorted = this.topUsers.slice(0);
            sorted.sort(function (a, b) {
                return a.amount - b.amount;
            });

            sorted.map((e) => {
                amount.push(e.amount);
                names.push(e.name);
            });

            amount = amount.reverse().slice(0, 4);
            names = names.reverse().slice(0, 4);
        }

        return [names, amount];
    }

    get brandChartData() {
        return {
            labels: this.sortBand[0],
            datasets: [
                {
                    label: "Top Brands " + this.currency,
                    backgroundColor: "#004C97",
                    yAxisID: "y-axis-1",
                    data: this.sortBand[1],
                },
            ],
        };
    }

    get customersChart() {
        return {
            labels: this.sortCustomers[0],
            datasets: [
                {
                    label: "Top Customers " + this.currency,
                    backgroundColor: "#28a745",
                    yAxisID: "y-axis-1",
                    data: this.sortCustomers[1],
                },
            ],
        };
    }

    get usersChart() {
        return {
            labels: this.sortUsers[0],
            datasets: [
                {
                    label: "Top Users " + this.currency,
                    backgroundColor: "#ffc107",
                    yAxisID: "y-axis-1",
                    data: this.sortUsers[1],
                },
            ],
        };
    }

    get multiAxisData() {
        return {
            labels: this.getRevenueExpenseChart[0],
            datasets: [
                {
                    type: "line",
                    label: "Sales " + this.currency,
                    backgroundColor: "#004C97",
                    data: this.getRevenueExpenseChart[1],
                    borderColor: "#42A5F5",
                    tension: 0.4,
                },
                {
                    type: "line",
                    label: "Sales Refund " + this.currency,
                    backgroundColor: "#FF6384",
                    data: this.getRevenueExpenseChart[2],
                    borderColor: "#ffc107",
                    tension: 0.4,
                },
                {
                    type: "line",
                    label: "Purchases " + this.currency,
                    backgroundColor: "#339966",
                    data: this.getRevenueExpenseChart[3],
                    borderColor: "#20c997",
                    tension: 0.4,
                },
                {
                    type: "line",
                    label: "Purchase Returns " + this.currency,
                    backgroundColor: "#c99777",
                    data: this.getRevenueExpenseChart[4],
                    borderColor: "#bf7128",
                    tension: 0.4,
                },
                {
                    type: "line",
                    label: "Stock Loss " + this.currency,
                    backgroundColor: "#d63031",
                    data: this.getRevenueExpenseChart[6],
                    borderColor: "#d63031", 
                    tension: 0.4,
                },
                {
                    type: "line",
                    label: "Stock Transfer Out " + this.currency,
                    backgroundColor: "#e74c3c",
                    data: this.getRevenueExpenseChart[7], 
                    borderColor: "#e74c3c",
                    tension: 0.4,
                },
                {
                    type: "line", 
                    label: "Stock Transfer In " + this.currency,
                    backgroundColor: "#9b59b6",
                    data: this.getRevenueExpenseChart[8], 
                    borderColor: "#9b59b6",
                    tension: 0.4,
                },
            ],
        };
    }

    get currency() {
        return this.store.getters.getCurrency;
    }

}
